import React from 'react';
import styles from './NewsCard.module.scss';

export default function NewsCard({ showArtWork = true, artworkUrl, message }) {
    return (
        <>
            <div className={styles.NotificationPreview}>
                {/* <a
                    href={props.showHyperlink ? props.hyperlink : undefined}
                    rel='noopener noreferrer'
                    target='blank'
                > */}
                <div className={styles.notificationWrapper}>
                    {showArtWork && artworkUrl && (
                        <div className={styles.ArtWorkPreviewWrapper}>
                            <img
                                className={styles.ArtWorkPreview}
                                src={artworkUrl?.split('?')[0].toString()}
                            />
                        </div>
                    )}
                    <p className={`${styles.MessageElipsis} u-m-top-1`}>
                        {message}
                    </p>
                </div>
                {/* </a> */}
            </div>
        </>
    )
}
